import {applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {Graphics} from 'pixi.js';

export type HorizontalLineProps = {
    width: number;
    size: number;
    color: number;
    alpha?: number;
};

export const HorizontalLine = PixiComponent<HorizontalLineProps, Graphics>('HorizontalLine', {
    create: () => {
        const graphics = new Graphics();

        graphics.name = 'HorizontalLine';

        return graphics;
    },

    applyProps: (instance, oldProps, newProps) => {
        const {size = 0, width = 0, color = 0, alpha = 1} = Object.assign(oldProps, newProps);

        instance.clear();
        instance.beginFill(color, alpha);
        instance.lineStyle(size, color, 1);
        instance.moveTo(0, 0);
        instance.lineTo(width, 0);
        instance.closePath();
        instance.endFill();

        applyDefaultProps(instance, oldProps, newProps);
    }
});